import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  matchPath,
  useSearchParams
} from "react-router-dom";
//import ContextApp from "./core/contexts/context.app";
import KishPortInfo from "./ui/views/kishPortInfo/Index";
import ContextApp from "./core/contexts/context.app";
import ProviderApp from "./core/providers/provider.app";
import HeaderNav from "./ui/components/Header/Header";
import FooterNav from "./ui/components/Footer/Footer";
// import BeforePageRender from "./ui/components/BeforePageRender";
import Profile from "./ui/views/Profile/Index";
import ListItems from "./ui/views/AmusementGroup/Index";
import IndexAmusementDetail from "./ui/views/AmusementDetail/Index";
import MyOrder from "./ui/views/UserOrder/Index";
import OrderList from "./ui/views/UserOrder/OrderList";
import OrderDetail from "./ui/views/UserOrder/OrderDetail";
import TransactionList from "./ui/views/Transaction/Index";
import WalletUser from "./ui/views/Wallet/Index";
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "./assets/style/main.css";
import "./assets/fonts/css/fontiran.css";
import BasketContent from "./ui/views/Basket/Index";
import Ticket from "./ui/views/UserOrder/Component/Ticket";
import HomeContent from "./ui/views/Home/Index";
import Refund from "./ui/views/Refund/Index";
import Withdrow from "./ui/views/Withdrow/Index";
import LoginRegister from "./ui/components/Login/LoginRegister";
import Payment from "./ui/views/Payment/Index";
import SearchPage from "./ui/views/_layout/Search";
import ContactUs from "./ui/views/ContactUs/Index";
import Weather from "./ui/views/Weather/Index";
import SiteMap from "./ui/views/_layout/sitemap.xml";

import BeforePageRender from "./ui/components/BeforePageRender";
import PageNotFound from "./ui/components/PageNotFound";
import AfterPayIndex from "./ui/views/AfterPay/AfterPayIndex";
import AmusementComplex from "./ui/views/AmusementComplex/Index";
import WithdrawFromWallet from "./ui/views/Wallet/WithdrawFromWallet";
import AmusementPackage from "./ui/views/AmusementPackage/Index";
import AboutUs from "./ui/views/AboutUs/Index";
import SiteRoles from "./ui/views/SiteRoles/Index";
import { ToastContainer } from "react-toastify";
import ServiceStorage from "./core/services/service.storage";

function Layout({ children }) {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  // لیست مسیرهایی که نمیخواهید HeaderNav و FooterNav را نمایش دهند
  const noHeaderFooterRoutes = ["/ticket/:id"]; // مسیرهای خاص بدون Header و Footer
  //const showHeaderFooter = !noHeaderFooterRoutes.includes(location.pathname);
  const showHeaderFooter = !noHeaderFooterRoutes.some((route) =>
    matchPath(route, location.pathname)
  );
  //Set PromoCode that is on the queryString to localStorage
  if (searchParams.get("prc") != null) {
    ServiceStorage.setPromoCode(searchParams.get("prc"));
  }
  
  //--------------------------------------------
  return (
    <>
      {showHeaderFooter && <HeaderNav />}
      <div className="main-content">{children}</div>
      {showHeaderFooter && <FooterNav />}
    </>
  );
}

function App() {
  return (
    <ProviderApp>
      <ContextApp.Consumer>
        {(context) => {
          return (
            <Router>
              <Layout>
                <ToastContainer rtl="true"></ToastContainer>
                <Routes>
                  {/* <Route path="/" element={<HomeContent />} /> */}
                  <Route
                    path="/"
                    element={
                      <>
                        <BeforePageRender
                          pageTitle="تفریحان - خرید تفریحات تمامی شهرها با تخفیف ویژه"
                          pageDescription="رزرو تفریحات و رستوران های موزیکدار کیش با تخفیف ویژه و تضمین  قیمت"
                          canonical={window.location.origin}
                          pageUrl={window.location.origin}
                          metaDel={[
                            "meta[property='og:image']",
                            "meta[property='og:image:width']",
                            "meta[property='og:image:height']",
                            "meta[property='og:video']",
                          ]}
                        />
                        <HomeContent />
                      </>
                    }
                  />

                  <Route
                    path="/details/:urlName"
                    element={
                      <>
                        <BeforePageRender />
                        <IndexAmusementDetail />
                      </>
                    }
                  />
                  <Route
                    path="/details/:urlName/pickdate"
                    element={
                      <>
                        <BeforePageRender />
                        <IndexAmusementDetail />
                      </>
                    }
                  />
                  <Route
                    path="/details/:urlName/selectname"
                    element={
                      <>
                        <BeforePageRender />
                        <IndexAmusementDetail />
                      </>
                    }
                  />
                  <Route
                    path="/details/:urlName/description"
                    element={
                      <>
                        <BeforePageRender />
                        <IndexAmusementDetail />
                      </>
                    }
                  />
                  <Route
                    path="/details/:urlName/selectplace"
                    element={
                      <>
                        <BeforePageRender />
                        <IndexAmusementDetail />
                      </>
                    }
                  />
                  <Route
                    path="/details/:urlName/importantAndNecessaryPoints"
                    element={
                      <>
                        <BeforePageRender />
                        <IndexAmusementDetail />
                      </>
                    }
                  />
                  <Route
                    path="/details/:urlName/comment"
                    element={
                      <>
                        <BeforePageRender />
                        <IndexAmusementDetail />
                      </>
                    }
                  />
                  <Route
                    path="/details/:urlName/allComments"
                    element={
                      <>
                        <BeforePageRender />
                        <IndexAmusementDetail />
                      </>
                    }
                  />
                  {/*    <Route*/}
                  {/*  path="/reserve"*/}
                  {/*  element={*/}
                  {/*    <>*/}
                  {/*      <BeforePageRender />*/}
                  {/*      <IndexAmusementDetail />*/}
                  {/*    </>*/}
                  {/*  }*/}
                  {/*/>*/}
                  <Route
                    path="/basket"
                    element={
                      <>
                        <BeforePageRender
                          pageTitle="سبد خرید"
                          pageDescription="سبد خرید"
                          canonical={window.location.origin + "/basket"}
                          pageUrl={window.location.origin + "/basket"}
                          metaDel={[
                            "meta[property='og:image']",
                            "meta[property='og:image:width']",
                            "meta[property='og:image:height']",
                            "meta[property='og:video']",
                          ]}
                        />
                        <BasketContent />
                      </>
                    }
                  />

                  <Route
                    path="/order"
                    element={
                      <>
                        <BeforePageRender pageTitle="سفارش ها" />
                        <MyOrder />
                      </>
                    }
                  />
                  <Route
                    path="/order/orderList"
                    element={
                      <>
                        <BeforePageRender pageTitle="سفارش ها" />
                        <OrderList />
                      </>
                    }
                  />
                  <Route
                    path="/order/orderDetail/:id"
                    element={
                      <>
                        <BeforePageRender pageTitle="جزئیات سفارش" />
                        <OrderDetail />
                      </>
                    }
                  />
                  <Route
                    path="/wallet"
                    element={
                      <>
                        <BeforePageRender pageTitle="کیف پول" />
                        <WalletUser />
                      </>
                    }
                  />
                  <Route
                    path="/withdrow"
                    element={
                      <>
                        <BeforePageRender pageTitle="درخواست های برداشت" />
                        <Withdrow />
                      </>
                    }
                  />
                  <Route
                    path="/refund"
                    element={
                      <>
                        <BeforePageRender pageTitle="درج اطلاعات حساب" />

                        <Refund />
                      </>
                    }
                  />
                  <Route
                    path="/withdrowFromWallet"
                    element={
                      <>
                        <BeforePageRender pageTitle="  برداشت از کیف پول" />

                        <WithdrawFromWallet />
                      </>
                    }
                  />

                  <Route
                    path="/aboutUs"
                    element={
                      <>
                        <BeforePageRender pageTitle="درباره ما" />

                        <AboutUs />
                      </>
                    }
                  />

                  <Route
                    path="/login"
                    element={
                      <>
                        <BeforePageRender
                          pageTitle="ورود / ثبت نام"
                          pageDescription="ورود / ثبت نام"
                          canonical={window.location.origin + "/login"}
                          pageUrl={window.location.origin + "/login"}
                          metaDel={[
                            "meta[property='og:image']",
                            "meta[property='og:image:width']",
                            "meta[property='og:image:height']",
                            "meta[property='og:video']",
                          ]}
                        />
                        <LoginRegister />
                      </>
                    }
                  />
                  <Route
                    path="/payment"
                    element={
                      <>
                        <BeforePageRender pageTitle="پرداخت" />
                        <Payment />
                      </>
                    }
                  />
                  <Route
                    path="/afterPay"
                    element={
                      <>
                        <BeforePageRender pageTitle="اطلاعات پرداخت" />
                        <AfterPayIndex />
                      </>
                    }
                  />
                  <Route
                    path="/search"
                    element={
                      <>
                        <BeforePageRender
                          pageTitle="جستجو"
                          pageDescription=" جستجو "
                          canonical={window.location.origin + "/search"}
                          pageUrl={window.location.origin + "/search"}
                          // no index
                          // + folow
                          metaDel={[
                            "meta[property='og:image']",
                            "meta[property='og:image:width']",
                            "meta[property='og:image:height']",
                            "meta[property='og:video']",
                          ]}
                        />
                        <SearchPage />
                      </>
                    }
                  />
                  <Route
                    path="/contact"
                    element={
                      <>
                        <BeforePageRender
                          pageTitle="تماس با ما"
                          pageDescription="تماس با ما"
                          canonical={window.location.origin + "/contact"}
                          pageUrl={window.location.origin + "/contact"}
                          metaDel={[
                            "meta[property='og:image']",
                            "meta[property='og:image:width']",
                            "meta[property='og:image:height']",
                            "meta[property='og:video']",
                          ]}
                        />
                        <ContactUs />
                      </>
                    }
                  />
                  <Route
                    path="/ticket/:id"
                    element={
                      <>
                        <BeforePageRender pageTitle="دانلود بلیط" />
                        <Ticket />
                      </>
                    }
                  />
                  <Route
                    path="/weather"
                    element={
                      <>
                        <BeforePageRender
                          pageTitle="آب و هوا"
                          pageDescription="آخرین وضعیت آب و هوای جزیره کیش"
                          canonical={window.location.origin + "/weather"}
                          pageUrl={window.location.origin + "/weather"}
                          metaDel={[
                            "meta[property='og:image']",
                            "meta[property='og:image:width']",
                            "meta[property='og:image:height']",
                            "meta[property='og:video']",
                          ]}
                        />
                        <Weather />
                      </>
                    }
                  />
                  <Route
                    path="/s/kishPortInfo"
                    element={
                      <>
                        <BeforePageRender
                          pageTitle="بندرگاه کیش"
                          pageDescription="بندرگاه کیش"
                          canonical={window.location.origin + "/s/kishPortInfo"}
                          pageUrl={window.location.origin + "/s/kishPortInfo"}
                          metaDel={[
                            "meta[property='og:image']",
                            "meta[property='og:image:width']",
                            "meta[property='og:image:height']",
                            "meta[property='og:video']",
                          ]}
                        />
                        <KishPortInfo />
                      </>
                    }
                  />
                  <Route
                    path="/profile"
                    element={
                      <>
                        <BeforePageRender pageTitle="پروفایل" />
                        <Profile />
                      </>
                    }
                  />
                  <Route
                    path="/transaction"
                    element={
                      <>
                        <BeforePageRender pageTitle="تراکنش های کیف پول" />
                        <TransactionList />
                      </>
                    }
                  />
                  <Route
                    path="/c/:urlParamCity?/:urlParamGroup?"
                    element={
                      <>
                        <ListItems />
                      </>
                    }
                  />
                  {/* <Route
                    path="/sitemap"
                    element={

                      <SiteMap />

                    }
                  /> */}
                  <Route
                    path="/siteRoles"
                    element={
                      <>
                        <BeforePageRender
                          pageTitle="قوانین و مقررات سایت"
                          // pageDescription="قوانین و مقررات سایت"
                          canonical={window.location.origin + "/siteRoles"}
                          pageUrl={window.location.origin + "/siteRoles"}
                          metaDel={[
                            "meta[property='og:image']",
                            "meta[property='og:image:width']",
                            "meta[property='og:image:height']",
                            "meta[property='og:video']",
                          ]}
                        />
                        <SiteRoles />
                      </>
                    }
                  />
                  <Route
                    path="/p/:urlName"
                    element={
                      <>
                        <BeforePageRender />
                        <AmusementComplex />
                      </>
                    }
                  />
                  <Route
                    path="/p/:urlName/comment"
                    element={
                      <>
                        <BeforePageRender />
                        <AmusementComplex />
                      </>
                    }
                  />
                  <Route
                    path="/g"
                    element={
                      <>
                        <BeforePageRender pageTitle="پکیج ها" />
                        <AmusementPackage />
                      </>
                    }
                  />
                  <Route
                    path="/p/:urlName/allComments"
                    element={
                      <>
                        <BeforePageRender />
                        <AmusementComplex />
                      </>
                    }
                  />
                  <Route
                    path="*"
                    status={404}
                    element={
                      <>
                        <BeforePageRender
                          pageTitle="صفحه پیدا نشد"
                          pageDescription=" "
                          canonical=" "
                          pageUrl=" "
                          metaDel={[
                            "meta[property='og:image']",
                            "meta[property='og:image:width']",
                            "meta[property='og:image:height']",
                            "meta[property='og:video']",
                          ]}
                        />
                        <PageNotFound />
                      </>
                    }
                  />
                  {/* <Route path="/login" element={<LoginPage />} /> */}

                  {/* <BeforePageRender pageTitle="تفریحان" /> */}
                  {/* </Route> */}
                  {/* ... Routeهای دیگر ... */}
                </Routes>
              </Layout>
            </Router>
          );
        }}
      </ContextApp.Consumer>
    </ProviderApp>
  );
}

export default App;
